import { CounterpartType, SettlementType, Ticket } from "./Entity";
import { StructuredOperationTypeFileModel } from "./StructuredOperationTypeFileModel";

export class StructuredOperationOrder extends Ticket {
  constructor() {
    super();
  }

  structuredOperationId: number = null;

  // Dados do Ativo
  settlementTypeId: SettlementType = null;
  SettlementType: CounterpartType = null;
  assetType: string = null;
  assetCode = null;
  expirationDate = null;
  amount: number = null;
  unitPrice = null;
  issueFee = null;
  isCetipVoice: boolean = null;
  propositionNumber: string = null;
  voiceNumber: string = null;

  operationTypeFile: StructuredOperationTypeFileModel = null;

  operationValue = null;
  operationCode: string = null;

  issueDate: Date = null;
  acquisitionDate: Date = null;
  subscriptionDate: Date = null;
  settlementDate: Date = null;
  operationDate: Date = null;

  statusDescription: string = null;

  isSecondaryMarket: boolean = false;
  annotations = null;
  objectAction: string = null;

  index: string = null;
  indexPercent: number = null;
  issuer: string = null;
  indexBase: number = null;
  interestType: number = null;
  indexTax: number = null;

  faceValue: number = null;
  updatedValue: number = null;
  updatedValueDate: Date = null;
  updatedExpirationDate: Date = null;
  paymentSquare: number = null;

  // Dados Carteira/Fundo
  portfolioName = "";
  portfolioDocument = "";
  portfolioBank = null;
  portfolioBranch = null;
  portfolioAccount = "";
  portfolioCetipAccount = "";
  portfolioFundId: number = null;
  portfolioFundAccountId: number = null;

  // Dados da Contraparte
  counterpartName = "";
  counterpartDocument = "";
  counterpartCetipAccount = "";
  counterpartType: number = null;
  counterPartBank = "";
  counterPartAccount = "";
  counterPartBranch = "";
  counterPartContact = "";
  command = "";

  // Dados do Devedor
  debtorName: string = null;
  debtorDocument: string = null;

  tempTicketId: any = null;
}
